module.exports = __webpack_public_path__ + "img/atlas-line.f3d741d0.svg";